module.exports = __webpack_public_path__ + "img/pauli-z-root.858a213a.svg";